// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"360":"70e166afd610ab0d80f7","558":"748ebdf20dedf35d1212"}[chunkId] + ".js";
};